// Function to toggle accordion visibility and update symbols
document.querySelectorAll(".accordion-button").forEach((button) => {
  button.addEventListener("click", (event) => {
    // Prevent the click from affecting parent accordions
    event.stopPropagation();

    const accordionContent = button.nextElementSibling;
    const symbol = button.querySelector(".symbol");

    // Check if the clicked accordion is open or closed
    const isOpen = accordionContent.style.display === "block";

    // Only close siblings (i.e. content within the same accordion)
    const parentAccordion = button.closest(".accordion-item").parentNode;
    parentAccordion
      .querySelectorAll(".accordion-content")
      .forEach((content) => {
        content.style.display = "none";
        content.previousElementSibling.querySelector(".symbol").textContent =
          "+"; // Reset symbol to "+"
      });

    // Open the clicked accordion (if it was closed) and toggle symbol
    if (!isOpen) {
      accordionContent.style.display = "block";
      symbol.textContent = "−"; // Change symbol to "-"
    } else {
      accordionContent.style.display = "none";
      symbol.textContent = "+"; // Change symbol back to "+"
    }
  });
});
